import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { MgService } from 'src/app/services/mg.service';

@Component({
  selector: 'app-client-invoice-list',
  templateUrl: './client-invoice-list.component.html',
  styleUrls: ['./client-invoice-list.component.scss']
})
export class ClientInvoiceListComponent implements OnInit {
  public invoices: any = [];
  public filter: any = {
    statuses: ['today', 'overdue', 'parcial'],
  };

  constructor(
    private api: MgService,
  ) {}

  ngOnInit(): void {
    this.api.loadBusinessInvoiceList()
      .toPromise()
      .then((res: any) => {
        this.invoices = res.data;
      })
      .catch(err => {
        console.log(err);
      });
  }

  get invoicesFiltered(): any[] {
    let invoices = this.invoices;

    if (this.filter.statuses) {
      invoices = invoices.filter((invoice: any) => {
        return this.filter.statuses.includes(invoice.status);
      });
    }

    if (this.filter.dateStart && this.filter.dateEnd) {
      invoices = invoices.filter((invoice: any) => {
        const date = moment(invoice.due_date);
        return date >= this.filter.dateStart && date <= this.filter.dateEnd;
      });
    }

    return invoices;
  }

  public filterChange(filter: any): void {
    this.filter = filter;
  }
}
